import { useRecoilState } from "recoil";
import { userAtom } from "../store/userAtom";
import api from "../api";

const useUser = () => {
  const [user, setUser] = useRecoilState(userAtom);

  const fetch = async () => {
    try {
      const { data } = await api.get("/api/user");
      setUser(data);
    } catch (err) {
      alert(err.message);
    }
  };

  return {
    user,
    onFetch: fetch,
  };
};

export default useUser;
